import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSettingsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={94}
    height={76}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={27}
      y={17.94}
      fill="url(#SettingsFull_svg__a)"
      rx={6}
    />
    <path
      fill="url(#SettingsFull_svg__b)"
      d="M50.046 32.478a2 2 0 1 1 0 4h-10.05a2 2 0 1 1 0-4zm12.376 0a2 2 0 0 1 0 4h-1.688a2 2 0 1 1 0-4z"
    />
    <path
      fill="url(#SettingsFull_svg__c)"
      d="M43.5 47.522a2 2 0 0 1 0 4h-3.504a2 2 0 1 1 0-4zm18.922 0a2 2 0 0 1 0 4h-9.421a2 2 0 0 1-.002-4z"
    />
    <path
      fill="url(#SettingsFull_svg__d)"
      d="M57.71 34.479a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m3 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
    />
    <path
      fill="url(#SettingsFull_svg__e)"
      d="M50.71 49.522a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m3 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
    />
    <path
      fill="url(#SettingsFull_svg__f)"
      d="M15.991 60.816a1.264 1.264 0 0 1 .443 2.144l-2.76 2.454a1.264 1.264 0 0 1-2.077-.689l-.747-3.616a1.264 1.264 0 0 1 1.636-1.456z"
    />
    <path
      fill="url(#SettingsFull_svg__g)"
      d="M86.533 38.95a1.116 1.116 0 0 1 1.852.556l1.294 5.468a1.117 1.117 0 0 1-1.407 1.326l-5.383-1.614a1.117 1.117 0 0 1-.445-1.882z"
    />
    <circle cx={59.311} cy={3.311} r={3.311} fill="url(#SettingsFull_svg__h)" />
    <circle cx={66.97} cy={72.911} r={2.97} fill="url(#SettingsFull_svg__i)" />
    <path
      fill="url(#SettingsFull_svg__j)"
      d="M1.858 11.722a.866.866 0 0 1-.17-1.49l3.5-2.592a.866.866 0 0 1 1.375.597l.496 4.327a.866.866 0 0 1-1.205.893z"
    />
    <defs>
      <linearGradient
        id="SettingsFull_svg__a"
        x1={27}
        x2={75.006}
        y1={35.083}
        y2={35.775}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EEF3FE" />
        <stop offset={1} stopColor="#DBE6FC" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__b"
        x1={36.878}
        x2={72.5}
        y1={36.313}
        y2={36.313}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8EB3FA" />
        <stop offset={1} stopColor="#DBE6FC" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__c"
        x1={28}
        x2={65.986}
        y1={51.356}
        y2={51.356}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DBE6FC" />
        <stop offset={1} stopColor="#8EB3FA" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__d"
        x1={55.209}
        x2={55.209}
        y1={28.979}
        y2={39.978}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8CEFB" />
        <stop offset={1} stopColor="#96B7FB" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__e"
        x1={48.209}
        x2={48.209}
        y1={44.022}
        y2={55.022}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8CEFB" />
        <stop offset={1} stopColor="#96B7FB" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__f"
        x1={11.277}
        x2={7.849}
        y1={74.263}
        y2={57.651}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.244} stopColor="#FEEEA3" />
        <stop offset={1} stopColor="#FAD208" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__g"
        x1={97.346}
        x2={78.25}
        y1={51.77}
        y2={46.044}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.244} stopColor="#FEEEA3" />
        <stop offset={1} stopColor="#FAD208" />
      </linearGradient>
      <linearGradient
        id="SettingsFull_svg__j"
        x1={7.685}
        x2={9.444}
        y1={0.099}
        y2={15.454}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.244} stopColor="#FEEEA3" />
        <stop offset={1} stopColor="#FAD208" />
      </linearGradient>
      <radialGradient
        id="SettingsFull_svg__h"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -6.62258 6.25918 -.28182 59.455 6.623)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B5CCFB" />
        <stop offset={1} stopColor="#DBE6FC" />
      </radialGradient>
      <radialGradient
        id="SettingsFull_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -5.94043 5.61447 -.25279 67.1 75.88)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B5CCFB" />
        <stop offset={1} stopColor="#DBE6FC" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgSettingsFull;
